import React from 'react';
import { useSelector } from 'react-redux';

/**
 * What a screen reader says of each outcome: the band's message, in a
 * polite region, or an assertive one for an error. Both are always mounted
 * — a region that appears with its text is not always read — and each
 * message mounts anew (`key`), so the same words twice are said twice.
 * The band (`FeedbackBand`) only shows.
 */
export const OperatorLiveRegion = () => {
  const signal = useSelector((state) => state.operatorDevice.signal);
  const assertive = signal?.tone === 'error';

  return (
    <div className="sr-only">
      <div role="status" aria-live="polite" aria-atomic="true" data-testid="operator-live-polite">
        {signal && !assertive && <p key={signal.id}>{signal.message}</p>}
      </div>
      <div role="alert" aria-live="assertive" aria-atomic="true" data-testid="operator-live-assertive">
        {signal && assertive && <p key={signal.id}>{signal.message}</p>}
      </div>
    </div>
  );
};
